import React from 'react';
import { Provider } from 'react-redux';

import configureStore from '../store/mobileMenuStore';
import MobileMenuContainer from '../containers/MobileMenuContainer';
import MobileMenuV2 from '../components/MobileMenuV2';

const MobileMenuApp = (props) => (
  props.navigationV2
    ? <MobileMenuV2 {...props} />
    : (
      <Provider store={configureStore(props)}>
        <MobileMenuContainer />
      </Provider>
    )
);

export default MobileMenuApp;
